import { LoctopusClient } from '@loctopus/ticketing-sdk';
import type { CheckoutRuntimeConfig } from '../theme/types';

/**
 * Only the public key is ever constructed into a client here - this app is browser code and must
 * never see a secret key (hard rule: "only the PUBLIC key is ever used client-side").
 */
export function createCheckoutClient(config: CheckoutRuntimeConfig): LoctopusClient {
  return new LoctopusClient({
    baseUrl: config.baseUrl,
    publicKey: config.publicKey,
  });
}
